/**
 * RFC4180 field escaping: quotes a value (doubling any embedded `"`) when it
 * contains a comma, quote, or newline — needed so a `\n`-joined multi-utility cell
 * value (see `columns.tsx`) survives as a wrapped multi-line cell when the CSV is
 * opened in Excel/Sheets, instead of being corrupted by an unquoted embedded comma
 * or newline.
 */
export function csvEscapeField(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replaceAll('"', '""')}"`;
  }
  return value;
}
